import { AxiosResponseAndError, ResponseType } from '../types/axiosResponseType';
import { useMutation } from '@tanstack/react-query';
import ApiRequest from '../ApiRequest';
import { requestURLs } from '@/Environment';
import { taskBulkDeleteSchema } from '@backend/src/schemas/taskSchema';
// import { ResponseType } from 'axios';
import { z } from "zod";



type MultipaleTaskRemoveResponseType = ResponseType<null>;

function useMultipaleTaskRemoveMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<MultipaleTaskRemoveResponseType>["response"],
    AxiosResponseAndError<MultipaleTaskRemoveResponseType>["error"],
    z.infer<typeof  taskBulkDeleteSchema>
   
  >({
    mutationFn: (data) =>
      ApiRequest.delete<MultipaleTaskRemoveResponseType>(`${requestURLs.task}selectedTask`,{data:data} ),
  });

  return mutation;
}

export default useMultipaleTaskRemoveMutation;